import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');
const filter = require('lodash/filter');
const find = require('lodash/find');
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const CollaboratorActions = require('../../actions/CollaboratorActions');
const CollaboratorStore = require('../../stores/CollaboratorStore');
const SignInStore = require('../../stores/SignInStore');
const StringUtil = require('../../../../app/shared/StringUtil');
import ConfirmModal from '../modal/ConfirmModal';
import DateString from '../common/DateString';
import AccessibleIcon from '../common/AccessibleIcon';
import ProjectRoleDropdown from '../common/ProjectRoleDropdown';

const propTypes = {
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    canEdit: PropTypes.bool,
    isOrgProject: PropTypes.bool,
    orgPossibleCollaborators: PropTypes.arrayOf(PropTypes.object),
    canViewOrgMembers: PropTypes.bool
};

const defaultProps = {
    canEdit: false,
    isOrgProject: false,
    orgPossibleCollaborators: [],
    canViewOrgMembers: false
};

class ProjectCollaborators extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collaboratorStoreState: CollaboratorStore.getStateProject(this.props.projectId),
            signInStoreState: SignInStore.getState(),
            modalState: {
                "confirmRemove": false,
            },
            newUserEmail: '',
            newUserRole: '',
            removeUserFxn: null,
            removeUserMsg: '',
            addUserActionId: null,
            addUserError: ''
        }

        this.onNewUserEmailChange = this.onNewUserEmailChange.bind(this);
        this.onNewUserRoleChange = this.onNewUserRoleChange.bind(this);
        this.onRemoveUser = this.onRemoveUser.bind(this);
        this.removeUser = this.removeUser.bind(this);
        this.closeConfirmModal = this.closeConfirmModal.bind(this);
        this.onNewUserAdd = this.onNewUserAdd.bind(this);
        this.onUpdateCollabPermissions = this.onUpdateCollabPermissions.bind(this);

        this.unsubscribes = [
            CollaboratorStore.listen(this.onCollaboratorStoreStateChange.bind(this)),
            SignInStore.listen(this.onSignInStoreStateChange.bind(this)),

        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreStateChange(newState) {
        this.setState({signInStoreState:newState});
    }

    onCollaboratorStoreStateChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.addUserActionId) {
            if (!newState.action.error) {
                additionalState = { ...additionalState, newUserEmail: '', newUserRole: '', addUserActionId: null, addUserError: '' };
            }
            else {
                additionalState = {
                    ...additionalState,
                    addUserActionId: null,
                    addUserError: newState.action.error.responseText || Strings['en'].common.ERROR
                };
            }
        }

        this.setState({
            collaboratorStoreState: CollaboratorStore.getStateProject(this.props.projectId),
            ...additionalState
        });
    }

    onNewUserEmailChange(e) {
        this.setState({
            newUserEmail: e.target.value,
            addUserError: '', // clear error
        });
    }
    onMemberSearchListClick(value,e) {
        this.setState({
            newUserEmail: value,
            addUserError: '', // clear error
        });
    }

    onNewUserRoleChange(roleToken) {
        this.setState({
            newUserRole: roleToken,
            addUserError: '', // clear error
        });
    }

    onRemoveUser(userId, firstName, lastName) {
        this.setState({
            removeUserMsg: `Are you sure you would like to remove ${firstName} ${lastName} from this project?`,
            removeUserFxn: this.removeUser.bind(this, userId),
            modalState: { ...this.state.modalState, confirmRemove: true }
        });
    }

    closeConfirmModal() {
        this.setState({
            removeUserMsg: '',
            removeUserFxn: null,
            modalState: { ...this.state.modalState, confirmRemove: false }
        });
    }

    removeUser(userId) {
        this.setState({ modalState: { ...this.state.modalState, confirmRemove: false } });
        const actionId = uuid.v4();
        CollaboratorActions.deleteProjectPermission(actionId, { projectID: this.props.projectId, userId: userId });
    }

    onNewUserAdd() {
        if (!this.state.newUserEmail) {
            this.setState({ addUserError: Strings['en'].project.collaborators.EMAIL_MISS_ERR });
            return;
        }

        // TODO: check email against validity regex

        if (!this.state.newUserRole) {
            this.setState({ addUserError: Strings['en'].project.collaborators.ROLE_MISS_ERR });
            return;
        }

        const actionId = uuid.v4();
        this.setState({ addUserActionId: actionId }, () => {
            CollaboratorActions.setProjectPermission(actionId, { projectID: this.props.projectId,  email: this.state.newUserEmail, roleToken: this.state.newUserRole });
        });
        
    }

    onUpdateCollabPermissions(userId, roleToken) {
        const actionId = uuid.v4();
        CollaboratorActions.setProjectPermission(actionId, { projectID: this.props.projectId, userId: userId, roleToken: roleToken });
    }

    render() {
        if (!this.state.collaboratorStoreState.initialized) {
            return null;
        }

        const collabs = this.state.collaboratorStoreState.pCollaborators;
        const isSiteAdmin = this.state.signInStoreState.userInfo.admin;
        // include a special override so that org owners & org admins can edit their own project permissions
        const updatedCollabs = collabs.map((collab) => {
            if (this.state.signInStoreState.userInfo.id === collab.id) {
                const orgCollab = this.props.isOrgProject && this.props.orgPossibleCollaborators ? this.props.orgPossibleCollaborators.find(orgCollab => orgCollab.id === collab.id) : null;
                if (
                    orgCollab 
                    && (orgCollab.role_token === Globals.users.roles.ORG_OWNER || orgCollab.role_token === Globals.users.roles.ORG_ADMIN)
                ) {
                    return { ...collab, overrideCanEdit: true };
                }
            }

            return collab;
        });

        const sortedCollabs = sortBy(updatedCollabs, 'last_name');
        let searchResultElement = null;
        let addUserDisabled = false;
        const showOrgCollabsUI = this.props.isOrgProject && this.props.canEdit && this.props.canViewOrgMembers;
        if (showOrgCollabsUI) {
            const searchTerm = this.state.newUserEmail.toLowerCase();
            let exactEmailFound = false;
            const searchTitle = searchTerm ? Strings['en'].project.collaborators.SEARCH_TITLE_POST : Strings['en'].project.collaborators.SEARCH_TITLE_PRE;
            let searchFeedback = '';
            let matchTotal = 0; // possible members that are checked vs the search term
            const selectableMembers = this.props.orgPossibleCollaborators.filter((member) => {
                const collab = find(collabs, { id: member.id });
                if (collab) {
                    return false;
                }

                // show user their own member account only if that account is an OWNER or ADMIN
                if (
                    (this.state.signInStoreState.userInfo.id === member.id)
                    && (member.role_token !== Globals.users.roles.ORG_OWNER && member.role_token !== Globals.users.roles.ORG_ADMIN) 
                ) {
                    return false;
                }

                if (!member.email) {
                    if (GlobalConfig.DevMode) {
                        console.log("user with no email:", member);
                    }
                    return false;
                }

                if (member.email === this.state.newUserEmail) {
                    exactEmailFound = true;
                }

                matchTotal++;
                if (searchTerm) {
                    if ((member.first_name && member.first_name.toLowerCase().indexOf(searchTerm) >= 0) ||
                        (member.last_name && member.last_name.toLowerCase().indexOf(searchTerm) >= 0) ||
                        (member.email.toLowerCase().indexOf(searchTerm) >= 0) ) {
                        return true;
                    }
                    return false;
                }
                return true;
            });
            
            addUserDisabled = (exactEmailFound === false);
            if (this.props.orgPossibleCollaborators.length === 0) {
                searchFeedback = Strings['en'].project.collaborators.SEARCH_NO_MEMBERS;
            }
            else if (matchTotal === 0) {
                searchFeedback = Strings['en'].project.collaborators.SEARCH_NO_RESULT;
            }
            else if (searchTerm) {
                searchFeedback = selectableMembers.length + " / " + matchTotal + " " + Strings['en'].project.collaborators.SEARCH_MATCHES_ITEM_TERM;
            }

            searchResultElement = (
                <div>
                    <ul className="padding-lr-md margin-bottom-15">
                        <li className="termListing">{searchTitle}</li>
                        {selectableMembers.map((user) => { return (
                            <li className="termListing--noBorder" key={user.id}>
                                <div className="termListing__termContainer">
                                    <span className="clickable-line" onClick={this.onMemberSearchListClick.bind(this, user.email)}>
                                    {(!user.unverified) ?
                                        `${user.first_name} ${user.last_name} - ${user.email}`
                                        :
                                        `${Strings['en'].project.collaborators.PENDING_STATUS_INDIC} - ${user.email}`
                                    }
                                    </span>
                                </div>
                            </li>
                        )})}
                        <li className="termListing--noBorder"><span className="search-feedback">{searchFeedback}</span></li>
                    </ul>
                </div>
            );
        }

        return (
            <div>
                <ul className="padding-lr-md margin-bottom-15">
                    { sortedCollabs.map((user) => { return (
                    <li className="termListing" key={user.id}>
                        <div className="termListing__termContainer">
                            {(!user.unverified) ?
                                <span>{user.first_name} {user.last_name} <a href={`mailto:${user.email}`} className="text-md">{user.email}</a></span>
                                :
                                `${user.email} ${Strings['en'].project.collaborators.PENDING_STATUS_INDIC}`
                            }
                            {(!user.unverified && isSiteAdmin) &&
                                <span className="termDescription margin-top-sm">
                                    {Strings['en'].project.collaborators.LAST_ACTIVE}:
                                    <DateString
                                        className="margin-left-sm"
                                        date={user.active_at}
                                        customFormat="YYYY-MM-DD"
                                    />
                                </span>
                            }
                        </div>
                        <div className="termListing__control">
                            { this.props.canEdit && (this.state.signInStoreState.userInfo.id !== user.id || user.overrideCanEdit) ?
                                <ProjectRoleDropdown
                                    id={`project-role-${user.id}`}
                                    selectedRoleToken={user.project_role_token}
                                    onRoleChange={this.onUpdateCollabPermissions.bind(this, user.id)}
                                />
                                :
                                StringUtil.getStringForRoleToken(user.project_role_token)
                            }
                            { this.props.canEdit && (this.state.signInStoreState.userInfo.id !== user.id || user.overrideCanEdit) ?
                                <button
                                    className="bare-text-button glyph margin-left-md"
                                    onClick={this.onRemoveUser.bind(this, user.id, user.first_name, user.last_name)}
                                >
                                    <AccessibleIcon
                                        label={Strings['en'].common.REMOVE}
                                        showLabelAsTitle
                                    >
                                        <span className="fa fa-remove" aria-hidden={true}/>
                                    </AccessibleIcon>
                                </button>
                                :
                                null
                            }
                        </div>
                    </li>
                    )})}
                    {(this.props.canEdit) ?
                        <li className="termListing--noBorder" key="newUser">
                            <div className="termListing__termContainer">
                                <input
                                    type="text"
                                    aria-label="new collaborator email address"
                                    placeholder={showOrgCollabsUI ? "search" : "email address"}
                                    value={this.state.newUserEmail}
                                    onChange={this.onNewUserEmailChange}
                                />
                                <div className="termListing__feedback color-error">
                                    {this.state.addUserError}
                                </div>
                            </div>
                            <div className="termListing__control">
                                <ProjectRoleDropdown
                                    selectedRoleToken={this.state.newUserRole}
                                    onRoleChange={this.onNewUserRoleChange}
                                />
                                <button
                                    className="bare-text-button glyph margin-left-md"
                                    disabled={!!this.state.addActionId || addUserDisabled}
                                    onClick={this.onNewUserAdd}
                                >
                                    <AccessibleIcon
                                        label={Strings['en'].project.collaborators.ADD_NEW_COLLAB}
                                        showLabelAsTitle
                                    >
                                        <span className="fa fa-plus" aria-hidden={true} />
                                    </AccessibleIcon>
                                </button>
                            </div>
                        </li>
                        :
                        null
                    }
                </ul>
                {searchResultElement}
                { this.state.modalState.confirmRemove &&
                    <ConfirmModal
                        show={true}
                        modalTitle={Strings['en'].project.collaborators.remove_modal.TITLE}
                        text={this.state.removeUserMsg}
                        buttonText={Strings['en'].common.CONFIRM}
                        closeHandler={this.closeConfirmModal}
                        confirmHandler={this.state.removeUserFxn}
                    />
                }
            </div>
        );

    }

}

ProjectCollaborators.propTypes = propTypes;
ProjectCollaborators.defaultProps = defaultProps;


export default ProjectCollaborators;
